import Location from './main.js';
export default Location;
